// removed by extract-text-webpack-plugin
module.exports = {"white":"_2UgroRkMYfHQnTWzjuLWcA","gray":"_1EfgvPin2rXKKDYcOg0E_8","small":"_2FJg5U-trdcAZafzE5Mf2k","gradientLogo":"_3ygU6u4_0Bi79pz-dUYv0p","logoPath":"_1m5DdxUIE5Zli2F2JaWFh5","stop1":"_3I-snJM59PF4Vtrs572usG","stop2":"_3-ZvRTDMcR67wEUrm8bfPH","stop3":"_37b5dkbWO75cUA5CeKJBbZ"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/logo/logo.scss
// module id = 416
// module chunks = 0